import ArticleLayout from '@/components/base/ArticleLayout';
import { articlePrincipianti } from '@/mocks/articles';

export default function ArticlePrincipianti() {
  return <ArticleLayout article={articlePrincipianti} currentSlug="/come-usare-itaobuy-principianti" />;
}